import React, { useState, useEffect } from "react";
import {
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

import { Link } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux";
import firebase from "../utils/firebaseConfig"

import tableIcons from "../components/tableFormatting/tableIcons";

import Kanban from "../components/Kanban";

const DiscussionBoard = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [dataMaster, setDataMaster] = useState([]);
  const [data, setData] = useState([]);
  const dataFilter = [];
  const localStore = useSelector(state => state.nanoCompDataReducer);
  const auth = useSelector(state => state.firebase);

  const [listItems, setListItems] = useState([]);
  const [selectedBoard, setSelectedBoard] = useState();

  const [open, setOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleOpen = () => {
    setMenuOpen(true);
}
const handleClose = () => {
    setMenuOpen(false);
}

useEffect(() => {
  const discussionList = [];
  discussionList.push({
    name: "General"
  })
  dataMaster.map((d, i) => {
    discussionList.push({
      name: d.name
    })
  })
  setListItems(discussionList)
  setSelectedBoard(discussionList[0].name)
},[dataMaster])

  const dispatch = useDispatch();

useEffect(() => {
  setIsLoading(true);
  async function getdata() {
    const ref = firebase
        .firestore()
        .collection("nanoCompetencies");
      const snapshot = await ref.get();
      const fetchedData = []
      const sortedData = []
      snapshot.forEach(doc => {
        fetchedData.push(doc.data());
      });
    fetchedData.sort((a, b) => (a.index > b.index) ? 1 : -1)

      fetchedData.map((d,i) => {
        if(d.author == auth.auth.uid) {
          sortedData.push(d)
        }
      })
      setDataMaster(fetchedData)
      setData(sortedData)
    }

    getdata()

    setTimeout(() => {
      setIsLoading(false);

    }, 1000)
},[localStore])

  
return (
  <div>
    {isLoading == true ? (
      <CircularProgress style={{ display: "flex", position: "absolute", top: "50%", left: "50%", marginRight: "-50%", transform: "translate(-50%, -50%)" }} />
    ) : (
      <>
        <Grid>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            justifyContent: "center"
          }}> 
            <IconButton
              style={{ position: "absolute", left: "5vw", marginTop: "20px" }}
            >
              <Link 
                to={-1}> 
                <tableIcons.PreviousPage color="primary"  />
              </Link>
            </IconButton>
      
            <h1 className="pageHeader1">Discussion Board</h1>
            <IconButton
              style={{ position: "absolute", right: "5vw", marginTop: "20px" }}>
                
                <tableIcons.CommentIcon />
            </IconButton>
          </div>
        </Grid>

        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justify="center"
          style={{ minHeight: '100vh' }}
        >

          <FormControl style={{ minWidth: "40vw", maxWidth: "90vw", marginBottom: "20px" }}>           
            <InputLabel id="demo-simple-select-label">
              Board
            </InputLabel>

            <Select
              value={selectedBoard}
              defaultValue={listItems[0].name}
              label="Template"
              onChange={(e) => setSelectedBoard(e.target.value)}
            >
              {listItems.map((d, i) => (
              
                <MenuItem value={d.name} key={i}>{d.name}</MenuItem>
                
              ))}
    
            </Select>
          </FormControl>
          
          <Kanban />
         
        </Grid>
     </>
    )}
</div>
  );
};


export default DiscussionBoard;